import React from "react";

const Resend = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.317 10.0254H16.1257C8.84521 10.0254 8.84521 13.8963 8.84521 17.3059V20.2543C8.84521 20.6167 9.00993 20.9462 9.28995 21.1603C9.56997 21.3744 9.94882 21.4568 10.2947 21.358C11.036 21.1603 11.9584 21.0615 13.062 21.0615C14.1656 21.0615 14.3962 21.1932 15.0551 21.6874L16.554 23.2687C17.6247 24.4217 19.1565 25.0806 20.7378 25.0806C22.3191 25.0806 23.8345 24.4217 24.9216 23.2687L26.4206 21.6874C27.0794 21.1932 27.31 21.0615 28.4136 21.0615C29.5173 21.0615 30.4397 21.1603 31.1809 21.358C31.5268 21.4568 31.8892 21.3744 32.1857 21.1603C32.4657 20.9462 32.6304 20.6003 32.6304 20.2543V17.3059C32.5975 13.8963 32.5975 10.0254 25.317 10.0254Z"
      fill="#7E858F"
    />
    <path
      d="M24.4768 8.29667C24.0486 8.72493 23.3403 8.72493 22.912 8.29667L21.8414 7.226V15.083C21.8414 15.6925 21.3472 16.2031 20.7213 16.2031C20.0954 16.2031 19.6012 15.709 19.6012 15.083V7.226L18.5305 8.29667C18.1023 8.72493 17.394 8.72493 16.9657 8.29667C16.5375 7.8684 16.5375 7.16011 16.9657 6.73185L19.9306 3.76694C19.9471 3.75046 19.9471 3.75046 19.9636 3.75046C20.0624 3.6681 20.1612 3.58575 20.293 3.53633C20.4413 3.47044 20.573 3.4375 20.7213 3.4375C20.8695 3.4375 21.0013 3.47044 21.1496 3.51986C21.2813 3.56927 21.4131 3.65163 21.5119 3.76694L24.4768 6.73185C24.9051 7.16011 24.9051 7.8684 24.4768 8.29667Z"
      fill="#40E5A0"
    />
    <path
      d="M31.7412 19.1347C30.8023 18.8876 29.6987 18.7559 28.381 18.7559C26.5526 18.7559 25.8773 19.2006 24.9384 19.9089C24.889 19.9418 24.8395 19.9912 24.7901 20.0407L23.2253 21.7043C21.9076 23.0879 19.5356 23.1044 18.2179 21.6878L16.6531 20.0407C16.6037 19.9912 16.5543 19.9418 16.5048 19.9089C15.566 19.2006 14.8906 18.7559 13.0623 18.7559C11.7445 18.7559 10.6409 18.8876 9.70201 19.1347C5.78174 20.1889 5.78174 23.3021 5.78174 26.0364V27.5682C5.78174 31.7027 5.78174 36.3806 14.5941 36.3806H26.8491C32.6966 36.3806 35.6615 33.4157 35.6615 27.5682V26.0364C35.6615 23.3021 35.6615 20.1889 31.7412 19.1347ZM24.5595 30.4508H16.8837C16.2578 30.4508 15.7471 29.9402 15.7471 29.2978C15.7471 28.6554 16.2578 28.1448 16.8837 28.1448H24.5595C25.1855 28.1448 25.6961 28.6554 25.6961 29.2978C25.6961 29.9402 25.1855 30.4508 24.5595 30.4508Z"
      fill="url(#paint0_linear_707_21455)"
    />
    <path
      d="M25.696 29.2976C25.696 29.94 25.1854 30.4506 24.5595 30.4506H16.8836C16.2577 30.4506 15.7471 29.94 15.7471 29.2976C15.7471 28.6552 16.2577 28.1445 16.8836 28.1445H24.5595C25.1854 28.1445 25.696 28.6552 25.696 29.2976Z"
      fill="#7E858F"
    />
    <defs>
      <linearGradient
        id="paint0_linear_707_21455"
        x1="20.7216"
        y1="18.7559"
        x2="20.7216"
        y2="36.3806"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#40E5A0" />
        <stop offset="1" stopColor="#33A590" />
      </linearGradient>
    </defs>
  </svg>
);

export default Resend;
